import { defineStore } from "pinia";
import { ref } from "vue";

const useAdminStatsStore = defineStore(
	"admin-stats",
	() =>
	{
		const usersCount = ref<number>(0);
		const userSubscriptionsCount = ref<number>(0);
		const unreadMessagesCount = ref<number>(0);
		const unreadSurveyUsersCount = ref<number>(0);
		const claimedLostItemsCount = ref<number>(0);
		const pendingAttendeesCount = ref<number>(0);

		return {
			usersCount,
			userSubscriptionsCount,
			unreadMessagesCount,
			claimedLostItemsCount,
			unreadSurveyUsersCount,
			pendingAttendeesCount,
		};
	},
);

export default useAdminStatsStore;
